function SearchArea(props: any) {
  let myProps = {
    countInfo: { "tot": 0 },
    listOpt: {},
    list: (inOptObj: any) => {},
    goCallBackData: () => {},
    closePopup: () => {},
    ...props
  };
  let countInfo=myProps.countInfo;
  let listOpt=myProps.listOpt;

  return (
    <div className="btn-box-left relative h-8">
      <b>총 <span className="text-blue-600">{countInfo.tot}</span> 명</b>
      <span>
        <input type="text" className="search-input" placeholder="이름" name="s_user_name_like"
          value={listOpt.s_user_name_like}
          onChange={(e: any) => {
            myProps.list({ "now_page": "1", "s_user_name_like": e.target.value });
          }} 
          style={{width:80}} />
      </span>
      <span className="ml-1">
        <input type="text" className="search-input" placeholder="아이디" name="s_id_like"
          value={listOpt.s_id_like}
          onChange={(e: any) => {
            myProps.list({ "now_page": "1", "s_id_like": e.target.value });
          }} 
          style={{width:80}} />
      </span>
      <div className="absolute right-0 top-0 btn-box-right">
        <button className="btn btn-dark" onClick={() => { myProps.goCallBackData(); }}>선택</button>
        <button className="btn btn-line-gray" onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
    </div>
  );
};
export default SearchArea;